if (!customElements.get("carousel-slider")) {
  customElements.define(
    "carousel-slider",
    class CarouselSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.carousel = this.querySelector('[class*="grid-carousel"]');
        this.initialize();
      }

      initialize() {
        const autoplayEnabled = this.getAttribute("data-autoplay") === "true";
        const autoPlaySpeed = parseInt(this.getAttribute("data-speed"), 10) * 1000;

        // Flickity doesn't work with flex containers, so
        // to avoid flash of unstyled content and page jump, style the container
        // as block just before initialization. On mobile where the carousel
        // is converted to simple scroller we swap this to display: flex !important
        // using CSS.
        this.carousel.style.display = "block";
        this.flickity = new Flickity(this.carousel, {
          autoPlay: autoplayEnabled ? autoPlaySpeed : false,
          cellAlign: "left",
          groupCells: true,
          contain: true,
          resize: true,
          draggable: true,
          prevNextButtons: false,
          fade: false,
          cellSelector: ".grid-item",
          initialIndex: 0,
          pageDots: false,
          wrapAround: false,
          accessibility: false,
          watchCSS: true,
        });

        this.flickity.on("change", (index) => {
          const event = new CustomEvent("slider:slide-change", {
            detail: {
              id: this.getAttribute("id"),
              index,
            },
          });
          document.dispatchEvent(event);
        });
      }
    },
  );
}

if (!customElements.get("carousel-navigation")) {
  customElements.define(
    "carousel-navigation",
    class CarouselNavigation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init(retry = 1, maxRetry = 3) {
        if (retry === maxRetry) {
          return;
        }

        const id = this.getAttribute("for");
        this.carouselComponent = document.querySelector(`#${id}`);
        this.wrap = this.dataset.wrap === "true";

        if (!this.carouselComponent || !this.carouselComponent.flickity) {
          setTimeout(() => {
            this.init(retry + 1);
          }, 350);
          return;
        }

        this.flickity = this.carouselComponent.flickity;
        this.buttonPrev = this.querySelector(".js-prev");
        this.buttonNext = this.querySelector(".js-next");

        this.buttonPrev.addEventListener("click", (event) => {
          event.preventDefault();
          this.flickity.previous();
        });

        this.buttonNext.addEventListener("click", (event) => {
          event.preventDefault();
          this.flickity.next();
        });

        this.update();
        this.flickity.on("select", () => this.update());
        // Group size (slides per page) can change when the viewport
        // crosses a breakpoint, so disabled/auto-hide state must be
        // re-evaluated on resize — the `select` event alone isn't enough.
        this.flickity.on("resize", () => this.update());
      }

      update() {
        // Auto-hide the entire nav when all cells fit in a single page —
        // there is nothing to navigate to.
        if (!this.flickity.slides || this.flickity.slides.length <= 1) {
          this.setAttribute("hidden", "");
          return;
        }
        this.removeAttribute("hidden");

        if (this.wrap) {
          return;
        }

        this.enableButton(this.buttonPrev);
        this.enableButton(this.buttonNext);

        if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
          this.disableButton(this.buttonPrev);
        }
        if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
          this.disableButton(this.buttonNext);
        }
      }

      enableButton(button) {
        button.classList.remove("pill-nav-item-disabled");
        button.classList.remove("focus-none");
        button.setAttribute("aria-disabled", "false");
      }

      disableButton(button) {
        button.classList.add("pill-nav-item-disabled");
        button.classList.add("focus-none");
        button.setAttribute("aria-disabled", "true");
      }
    },
  );
}
